// Vendor imports
const _ = require('lodash')

const HIJACK_PROOF_JSON_PREFIX = '])}while(1);</x>'

function filterHijackProofJSON(str) {
  if (_.startsWith(str, HIJACK_PROOF_JSON_PREFIX)) {
    return str.substring(HIJACK_PROOF_JSON_PREFIX.length)
  }
  return str
}

function parseHijackProofJSON(str) {
  const filteredStr = filterHijackProofJSON(str)
  try {
    return JSON.parse(filteredStr)
  } catch (err) {
    return filteredStr
  }
}

function stringifyHijackProofJSON(msg) {
  return HIJACK_PROOF_JSON_PREFIX + JSON.stringify(msg)
}

module.exports = {
  filterHijackProofJSON,
  parseHijackProofJSON,
  stringifyHijackProofJSON
}
